import { styled } from '@linaria/react'
import React, { FC, ReactNode } from 'react'
import { colors } from '../styles/colors'
import ArrowSvg from '../svgr/Chevron'
import { Typography } from './Typography'

interface InfoCardProps {
  icon?: ReactNode
  children: ReactNode
  onClick?: () => void
  className?: string
}

export const InfoCard: FC<InfoCardProps> = ({
  icon,
  children,
  onClick,
  className,
}) => {
  return (
    <Container className={className} onClick={onClick} clickable={!!onClick}>
      <Content>
        {icon}

        <Typography fontSize={14} fontWeight={600} font="roboto">
          {children}
        </Typography>

        {onClick && (
          <ArrowContainer>
            <ArrowIcon />
          </ArrowContainer>
        )}
      </Content>
    </Container>
  )
}

const Container = styled.div<{ clickable: boolean }>`
  background: ${colors.grey100};
  border: 1px solid ${colors.grey100};
  border-radius: 16px;
  width: 100%;
  cursor: ${props => (props.clickable ? 'pointer' : 'default')};
  transition: background-color 0.2s ease;

  &:hover {
    background: ${props => (props.clickable ? colors.grey200 : colors.grey100)};
  }
`

const Content = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  color: ${colors.secondary};
`

const ArrowContainer = styled.div`
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${colors.secondary};
  transform: rotate(90deg);
  fill: ${colors.secondary};
`

const ArrowIcon = styled(ArrowSvg)`
  transform: rotate(270deg);
`
